var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrcode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3974 0H2.60259C1.16789 0 0 1.16786 0 2.60259V81.3974C0 82.8321 1.16786 84 2.60259 84H81.3974C82.8321 84 84 82.8321 84 81.3974V2.60259C84 1.16789 82.8327 0 81.3974 0ZM82.2651 81.3973C82.2651 81.8759 81.8767 82.265 81.3974 82.265H2.60259C2.12456 82.265 1.73486 81.8765 1.73486 81.3973L1.73547 2.60243C1.73547 2.12441 2.12515 1.73471 2.60319 1.73471H81.398C81.8767 1.73471 82.2657 2.12439 82.2657 2.60243L82.2651 81.3973Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6427 22.9319H38.186V20.388H40.7274V22.9319H38.186V25.4733H40.7274V30.5592H43.27V28.0159H45.8127V30.5592H48.3559V25.4733H53.4406V20.388H50.8979V22.9319H48.3559V20.388H45.8127V25.4733H43.27V20.388H45.8127V17.8454H43.27V15.3034H38.186V12.7607H35.6427V5.13281H25.4722V12.7607H28.0148V7.67545H33.1001V10.2181H30.5581V12.7607H33.1001V20.388H35.6427V22.9319Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.728 5.1333H43.2707V7.67594H40.728V5.1333Z",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3574 5.1333H50.8988V7.67594H48.3574V5.1333Z",
    fill: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9306 5.1333H5.13184V22.9321H22.9306V5.1333ZM20.3867 20.3885H7.67416V7.67594H20.3867V20.3885Z",
    fill: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2701 10.2184H40.7274V7.67578H38.186V12.7611H43.2701V10.2184Z",
    fill: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.27 7.67578H45.8133V10.2184H43.27V7.67578Z",
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8999 7.67578H53.4432V10.2184H50.8999V7.67578Z",
    fill: "#333333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9849 7.67578H58.5263V10.2184H55.9849V7.67578Z",
    fill: "#333333"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0688 22.9321H78.8676V5.1333H61.0688V22.9321ZM63.6127 7.67563H76.3247V20.3882H63.6127V7.67563Z",
    fill: "#333333"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2178 10.218H17.8457V17.8459H10.2178V10.218Z",
    fill: "#333333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1562 10.218H73.7829V17.8459H66.1562V10.218Z",
    fill: "#333333"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0151 12.761H30.5578V15.3036H28.0151V12.761Z",
    fill: "#333333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.27 12.761H45.8133V15.3036H43.27V12.761Z",
    fill: "#333333"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8994 17.8464H58.5274V15.3044H50.8994V12.7617H48.3574V20.389H50.8994V17.8464Z",
    fill: "#333333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9849 20.3887H58.5263V25.4739H55.9849V20.3887Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3872 25.4739H22.9305V28.0165H20.3872V25.4739Z",
    fill: "#333333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2402 28.0158H73.7829V30.559H78.8681V25.4731H71.2402V28.0158Z",
    fill: "#333333"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13184 28.0161H7.67447V33.1014H5.13184V28.0161Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7822 33.1016H76.3249V35.6442H73.7822V33.1016Z",
    fill: "#333333"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3872 35.6433H22.9305V38.1859H20.3872V35.6433Z",
    fill: "#333333"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8138 33.1015V30.5589H43.2705V35.6442H40.7279V30.5589H38.1853V28.0163H35.6426V30.5589H33.1V28.0163H35.6426V22.931H33.1V20.3877H30.5573V22.931H28.0147V17.8457H25.4721V28.0163H22.9294V30.5589H15.3015V28.0163H17.8441V25.4736H10.2162V30.5589H12.7589V35.6442H5.13281V40.7294H7.67545V38.1868H12.7607V43.2708H15.3034V53.442H10.2181V55.9853H17.846L17.8454 40.7288H20.388V38.1862H17.8454V35.6435H15.3028V33.1009H22.9307V35.6435H28.016V43.2702H25.4733V38.1862H22.9307V40.7288H20.3874V43.2715H22.9307V45.8147H28.016V50.9H30.5586V58.5279H33.1012V53.4426H35.6439V55.9859H38.1865V53.4426H40.7291V50.9H38.1865V43.2715H40.7291V50.9H43.2718V45.8147H45.815V43.2715H43.2718V40.7288H40.7291V38.1862H45.8144V35.6435H48.3577V33.1009L45.8138 33.1015ZM25.473 33.1015V30.5589H28.0156V25.4736H30.5583V33.1015H25.473ZM38.1868 40.7288H35.6442V48.3574H33.1015V43.2715H30.5589V38.1874H33.1015V35.6448H38.1868V40.7288Z",
    fill: "#333333"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7822 38.1875H78.8675V40.7301H73.7822V38.1875Z",
    fill: "#333333"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67432 40.7292H10.217V43.2719H7.67432V40.7292Z",
    fill: "#333333"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13184 43.2708H7.67447V45.814H5.13184V43.2708Z",
    fill: "#333333"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3574 43.2708H53.4415V45.814H48.3574V43.2708Z",
    fill: "#333333"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7822 43.2708H78.8675V45.814H73.7822V43.2708Z",
    fill: "#333333"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2178 45.8152H12.7604V48.3584H10.2178V45.8152Z",
    fill: "#333333"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3872 45.8152H22.9305V48.3584H20.3872V45.8152Z",
    fill: "#333333"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67399 50.9008H10.2166V48.3582H5.13135V58.5287H7.67399V50.9008Z",
    fill: "#333333"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7822 48.3582H78.8675V50.9008H73.7822V48.3582Z",
    fill: "#333333"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3872 50.9004V53.4424H22.9311V55.9857H20.3872V58.5283H25.4725V61.0697H28.0151V50.9004H20.3872Z",
    fill: "#333333"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.27 50.9004H48.3559V55.9857H43.27V50.9004Z",
    fill: "#333333"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8999 50.9004H53.4432V61.0709H50.8999V50.9004Z",
    fill: "#333333"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2402 50.9004H73.7829V53.443H71.2402V50.9004Z",
    fill: "#333333"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6968 53.4421H71.24V55.9854H68.6968V53.4421Z",
    fill: "#333333"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3242 53.4421H78.8675V55.9854H76.3242V53.4421Z",
    fill: "#333333"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7824 58.5277V61.0691H78.8677V58.5277H76.3244V55.9851H71.2397V58.5277H73.7824Z",
    fill: "#333333"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1011 58.5281H35.6437V61.0707H33.1011V58.5281Z",
    fill: "#333333"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M45.814 58.5281H48.3572V61.0707H45.814V58.5281Z",
    fill: "#333333"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1566 25.4739H58.5269V28.0165H55.9855V30.5592H61.0695V28.0165H63.6128V30.5592H66.156V33.1018H63.6128V30.5592H61.0695V33.1018H55.9855V30.5592H53.4422V28.0165H50.899V30.5592H48.3576V33.1018H53.4416V38.1871H50.8983V35.6444H48.3569V40.7297H58.5262V45.815H55.9848V48.3582H58.5262V50.9009H55.9848V53.4435H58.5262V55.9868H55.9848V61.0708H53.4416V63.6141H55.9848V68.6981H68.6968V66.1555H71.2401V63.6128H73.7827V61.0696H68.6974V55.9855H66.156V53.4423H63.6128V55.9855H61.0695L61.0683 40.7291H63.6116V50.9003H68.6956V48.3576H66.1542V45.8144H68.6956V48.3576H73.7809V45.8144H71.2382V38.1864H73.7809V35.6438H71.2382V28.0159H66.1542V25.4739H66.1566ZM55.9855 38.1877V35.645H58.5269V38.1877H55.9855ZM66.1566 58.5285V66.1564H58.5269V58.5285H66.1566ZM68.6974 43.272H66.156V40.7294H68.6974V43.272ZM68.6974 35.6447V38.1874H61.0695V35.6447H68.6974Z",
    fill: "#333333"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0151 61.0698H33.1004V63.6131H28.0151V61.0698Z",
    fill: "#333333"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6426 61.0698H38.1852V66.1551H35.6426V61.0698Z",
    fill: "#333333"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M43.27 61.0698H45.8133V68.6977H43.27V61.0698Z",
    fill: "#333333"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0688 61.0698H63.6121V63.6131H61.0688V61.0698Z",
    fill: "#333333"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13184 78.8686H22.9306V61.0698H5.13184V78.8686ZM7.67447 63.6134H20.387V76.3253H7.67447V63.6134Z",
    fill: "#333333"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3574 63.6133H50.8988V66.1559H48.3574V63.6133Z",
    fill: "#333333"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7822 63.6133H78.8675V66.1559H73.7822V63.6133Z",
    fill: "#333333"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2178 66.1558H17.8457V73.7837H10.2178V66.1558Z",
    fill: "#333333"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0153 66.1558H25.4727V73.7831H30.5586V71.2404H28.0153V66.1558Z",
    fill: "#333333"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6428 66.1558H33.1001V68.6972H30.5581V71.2404H35.6428V73.7831H38.186V68.6972H35.6428V66.1558Z",
    fill: "#333333"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M38.186 66.1558H40.7287V68.6984H38.186V66.1558Z",
    fill: "#333333"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8999 66.1558H53.4432V68.6984H50.8999V66.1558Z",
    fill: "#333333"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2402 66.1558H73.7829V68.6984H71.2402V66.1558Z",
    fill: "#333333"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8136 73.7832H43.271V76.3252H45.8136V78.8684H48.3569V68.6973H45.8136V73.7832Z",
    fill: "#333333"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4414 68.6973H55.9847V71.2405H53.4414V68.6973Z",
    fill: "#333333"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6963 71.2413H58.5263V73.7839H61.0684V76.3259H50.8984V78.8692H63.6122V76.3259H71.2395V68.698H68.6963V71.2413Z",
    fill: "#333333"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M40.728 71.241H43.2707V73.7836H40.728V71.241Z",
    fill: "#333333"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8999 71.241H53.4432V73.7836H50.8999V71.241Z",
    fill: "#333333"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7822 71.241H76.3249V76.325H73.7822V71.241Z",
    fill: "#333333"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5586 73.7832H33.1012V76.3258H30.5586V73.7832Z",
    fill: "#333333"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0151 76.325H30.5578V78.8682H28.0151V76.325Z",
    fill: "#333333"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1011 76.325H35.6437V78.8682H33.1011V76.325Z",
    fill: "#333333"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2402 76.325H73.7829V78.8682H71.2402V76.325Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.17dd21ef6d03b4bea308bec0cc05408b.svg";
export { ForwardRef as ReactComponent };